export default "__VITE_ASSET__01oCXfp9__"